import React, { useEffect, useRef, useState } from 'react'

const Home = () => {
    const [darkorlight, setdarkorlight] = useState(false);
    const [maintext, setmaintext] = useState('');
    const [previostext, setpreviostext] = useState('');
    const [previewtext, setpreviewtext] = useState('');

    useEffect(() => {
        if (darkorlight === false) {
            document.body.classList.add('dark');
        } else {
            document.body.classList.remove('dark');
        }
    }, [darkorlight]);

    const uppercaseconvert = () => {
        setmaintext(maintext.toUpperCase());
    };

    const lowercaseconvert = () => {
        setmaintext(maintext.toLowerCase());
    };

    const capitilizecaseconvert = () => {
        removespace();
        let newmaintext = maintext.toLowerCase();
        let answer = "";
        answer += newmaintext[0].toUpperCase();

        for (let i = 1; i < newmaintext.length - 1; i++) {
            if (newmaintext[i] !== " " && newmaintext[i - 1] === " ") {
                answer += newmaintext[i].toUpperCase();
            } else {
                answer += newmaintext[i];
            }
        };

        answer += newmaintext[newmaintext.length - 1];
        setmaintext(answer);
    };

    const removespace = () => {
        if (maintext === "") {

        } else {
            let answer = "";
            for (let i = 0; i < maintext.length - 1; i++) {
                if (maintext[i] !== ' ' || maintext[i + 1] !== ' ') {
                    answer += maintext[i];
                };
            }
            if (maintext[maintext.length - 1] !== ' ') {
                answer += maintext[maintext.length - 1];
            }
            setmaintext(answer);
        }
    };

    const clearalltext = () => {
        if (maintext.length > 0) {
            setpreviostext(maintext);
            setmaintext('');
            setpreviewtext('');
        }
    }

    const previoustext = () => {
        setmaintext(previostext);
        setpreviewtext(previostext);
    };

    const setsampletext = () => {
        const sample = "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Ipsa aut quas doloribus nulla. Asperiores atque aspernatur soluta itaque, voluptate vero ipsa! Quo harum cupiditate ad consectetur ducimus perferendis? Sapiente, tenetur?"
        setmaintext(sample);
        setpreviewtext(sample);
    };

    const inputRef = useRef(null);

    const handleCopyClick = () => {
        if (inputRef.current) {
            inputRef.current.select();
            document.execCommand('copy');
            window.getSelection().removeAllRanges();
        }
    };



    return (
        <>
            <div className="navbar">
                <div className="title">
                    WebText
                </div>
                <div className="switch">
                    <label>
                        Light Mode
                        <input type="checkbox" checked={darkorlight} onChange={(e) => {
                            setdarkorlight(e.target.checked)
                        }} />
                        <span className="lever"></span>
                        Dark Mode
                    </label>
                </div>
            </div>

            <div className="textinput">
                <textarea name="textin" ref={inputRef} id="textin" cols={10} rows={20} value={maintext} onChange={(e) => {
                    setmaintext(e.target.value);
                    setpreviewtext(e.target.value);
                }}></textarea>
            </div>

            <div className="allbut">
                <div className="buttonbox">
                    <div className="uppercase" onClick={uppercaseconvert}>To Upper Case</div>
                    <div className="uppercase" onClick={lowercaseconvert}>To Lower Case</div>
                    <div className="uppercase" onClick={capitilizecaseconvert}>To Capitalize</div>
                    <div className="uppercase" onClick={removespace}>Remove Spaces</div>
                    <div className="uppercase" onClick={clearalltext}>Clear All</div>
                    <div className="uppercase" onClick={previoustext}>Previous Text</div>
                    <div className="uppercase" onClick={setsampletext}>Sample Text</div>
                    <div className="uppercase" onClick={handleCopyClick}>Copy Current Text</div>
                </div>
            </div>

            <div className="textpreview">
                <div className="previewtit">
                    Text Preview
                </div>
                <div className="previewbix">
                    {previewtext}
                </div>
            </div>

            <div className="textcount">
                Number of letters in text is {maintext.length}
            </div>

            {/* average word length is 4.7 */}
            {/* number of words writing in a minute is 40 words */}

            <div className="timerequired">
                Average Time required to type the given text is <span>
                    {parseInt((maintext.length * 60) / (40 * 4.7))} seconds
                </span>  or approximately <span>
                    {parseInt((maintext.length) / (40 * 4.7))} minutes
                </span>
            </div>
        </>
    )
}

export default Home